import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

interface TabletMenuToggleProps {
    onToggle: (isOpen: boolean) => void;
    isOpen: boolean;
}

const TabletMenuToggle: React.FC<TabletMenuToggleProps> = ({ onToggle, isOpen }) => {
    const [isTablet, setIsTablet] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            // We now only differentiate between mobile (<768px) and full sidebar (>=768px)
            // for the main layout, so this tablet-specific toggle is no longer needed.
            // Keep it effectively disabled by never marking the screen as "tablet" here.
            const isTabletSize = false;
            setIsTablet(isTabletSize);
        };

        // Check on mount
        checkScreenSize();

        // Add event listener for resize
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const handleToggle = () => {
        onToggle(!isOpen);
    };

    // Only render on tablet screens
    if (!isTablet) {
        return null;
    }

    return (
        <button
            className="tablet-menu-toggle"
            onClick={handleToggle}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            data-testid="tablet-menu-toggle"
        >
            {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
    );
};

export default TabletMenuToggle;
